import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { remove } from "aws-amplify/storage";
import { setModalState, modalViewsConst } from "../../store/modalSlice";
import ModalBase from "./ModalBase";
import { ReactComponent as ArchiveIcon } from "../../assets/icons/archive.svg";

interface ConfirmDeleteFileModalProps {
  filePath?: string;
  fileName?: string;
  model?: {
    id: string;
    label: string;
    routeLong: string;
    routeShort: string;
    organizationId?: string;
  };
}

const ConfirmDeleteFileModal: React.FC<ConfirmDeleteFileModalProps> = ({
  filePath,
  fileName,
  model,
}) => {
  const dispatch = useDispatch();
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reopenFilesModal = () => {
    dispatch(
      setModalState({
        modalOpen: true,
        modalView: modalViewsConst.processedModelFiles,
        properties: { __modalSize: "lg", model },
      })
    );
  };

  const handleCancel = () => {
    reopenFilesModal();
  };

  const handleConfirm = async () => {
    setDeleting(true);
    setError(null);
    try {
      await remove({ path: filePath! });
      reopenFilesModal();
    } catch (err) {
      console.error("Error deleting file:", err);
      setError("Failed to delete file. Please try again.");
      setDeleting(false);
    }
  };

  return (
    <ModalBase
      title="Delete File"
      icon={<ArchiveIcon className="h-6 w-6" style={{ '--stroke-0': '#A2BBBF' } as React.CSSProperties} />}
      onClose={handleCancel}
      size="sm"
      footer={
        <>
          <button className="flex-1 eai-btn" onClick={handleCancel} disabled={deleting}>
            Cancel
          </button>
          <button
            className="flex-1 eai-btn-red"
            onClick={handleConfirm}
            disabled={deleting}
          >
            {deleting ? "Deleting…" : "Delete"}
          </button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <p className="text-gray-900 font-medium">
          Are you sure you want to permanently delete this file?
        </p>
        <p className="text-sm font-medium text-gray-800 bg-gray-100 rounded-lg px-3 py-2 font-mono break-all">
          {fileName}
        </p>
        <p className="text-sm text-red-600">This action cannot be undone.</p>
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    </ModalBase>
  );
};

export default ConfirmDeleteFileModal;
